export default function joinList(list: Array<string>) {
  const count = list.length;
  return count < 3
    ? list.join(' & ')
    : `${list.slice(0, count - 1).join(', ')} & ${list[count - 1]}`;
}
